import { render, staticRenderFns } from "./DeleteDialog.vue?vue&type=template&id=08390182&scoped=true"
import script from "./DeleteDialog.vue?vue&type=script&lang=ts"
export * from "./DeleteDialog.vue?vue&type=script&lang=ts"
import style0 from "./DeleteDialog.vue?vue&type=style&index=0&id=08390182&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08390182",
  null
  
)

export default component.exports